var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentLight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_12452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7.5V16.875",
    stroke: "url(#paint0_linear_290_12452)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35156 25.3126C7.2896 23.8738 8.57177 22.6918 10.0819 21.8736C11.5921 21.0554 13.2825 20.627 15 20.627C16.7175 20.627 18.4079 21.0554 19.9181 21.8736C21.4282 22.6918 22.7104 23.8738 23.6484 25.3126",
    stroke: "url(#paint1_linear_290_12452)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 7.5L15 11.25L3.75 7.5L15 3.75L26.25 7.5Z",
    stroke: "url(#paint2_linear_290_12452)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8398 9.63281C20.6998 10.5719 21.268 11.741 21.4751 12.9974C21.6822 14.2538 21.5193 15.5433 21.0063 16.7088C20.4933 17.8742 19.6522 18.8653 18.5857 19.561C17.5193 20.2568 16.2734 20.6273 15 20.6273C13.7266 20.6273 12.4808 20.2568 11.4143 19.561C10.3478 18.8653 9.50675 17.8742 8.99371 16.7088C8.48067 15.5433 8.31778 14.2538 8.52489 12.9974C8.73201 11.741 9.30019 10.5719 10.1602 9.63281",
    stroke: "url(#paint3_linear_290_12452)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_290_12452",
    x1: 4.25,
    y1: 7.5,
    x2: 4.25,
    y2: 16.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_290_12452",
    x1: 15,
    y1: 20.627,
    x2: 15,
    y2: 25.3126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_290_12452",
    x1: 15,
    y1: 3.75,
    x2: 15,
    y2: 11.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_290_12452",
    x1: 15,
    y1: 9.63281,
    x2: 15,
    y2: 20.6273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_12452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentLight1);
export default __webpack_public_path__ + "static/media/student_light1.d28de1c4d2cfbfa1aeed2efc8e967527.svg";
export { ForwardRef as ReactComponent };